import actions from '../../actionTypes';

export default filter => {
  return {
    type: actions.ADD_FILTER,
    filter
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/addFilter.js